import { makeAxiosRequest } from 'utils/apiMethods';

interface AuthApi {
  sendResetPasswordLink: (data: ResetPasswordLinkData) => Promise<any>;
  loginByRefreshToken: (data: RefreshTokenData) => Promise<any>;
  saveNewPassword: (data: NewPasswordData) => Promise<any>;
  confirmEmail: (data: ConfirmEmailData) => Promise<any>;
  signUp: (data: SignUpData) => Promise<any>;
  signIn: (data: SignInData) => Promise<any>;
  getUserData: (Data: UserData) => Promise<any>;
  updateAccount: (data: UpdateAccountData) => Promise<any>;
}

interface UserData {
  // Define the expected structure for userData endpoint
}

// Define the data structures for each endpoint
interface ResetPasswordLinkData {
  // Define the expected structure for sendResetPasswordLink endpoint
}

interface RefreshTokenData {
  // Define the expected structure for loginByRefreshToken endpoint
}

interface NewPasswordData {
  // Define the expected structure for saveNewPassword endpoint
}

interface ConfirmEmailData {
  // Define the expected structure for confirmEmail endpoint
}

interface SignUpData {
  // Define the expected structure for signUp endpoint
}

interface SignInData {
  // Define the expected structure for signIn endpoint
}

interface UpdateAccountData {
  // Define the expected structure for updateAccount endpoint
}

const authApi: AuthApi = {
  sendResetPasswordLink: makeAxiosRequest(
    `${process.env.REACT_APP_API_URL}/auth/send-reset-password-link`,
    {
      method: 'post',
    },
  ),
  loginByRefreshToken: makeAxiosRequest(
    `${process.env.REACT_APP_API_URL}/auth/login-by-refresh-token`,
    {
      method: 'post',
    },
  ),
  saveNewPassword: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/auth/save-new-password`, {
    method: 'post',
  }),
  confirmEmail: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/auth/confirm-email`, {
    method: 'post',
  }),
  signUp: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/auth/register`, {
    method: 'post',
  }),

  signIn: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/auth/login`, {
    method: 'post',
  }),
  getUserData: makeAxiosRequest(
    `${process.env.REACT_APP_API_URL}/users/`,
    {
      method: 'get',
    },
    true,
  ),
  updateAccount: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/auth/me`, {
    method: 'put',
  }),
};
export default authApi;
